/* State module for entities information, shared across the app. If a page needs to store specific information, use a module for the given page. */

// Mutations and Actions

const AUTHORIZATION_MODULE_PATH = 'authorizations';

export { AUTHORIZATION_MODULE_PATH };

export default (store) => {
  store.registerModule(AUTHORIZATION_MODULE_PATH, {
    namespaced: true,
    state: {
      isInactive: false,
      isDispatcher: false,
      isPEM: false,
      isREE: false,
      isMy360: false,
      isMobileeRollOut: false,
      hasRequestCreation: false,
      hasHIS: false,
      hasRegulatoryControl: false,
      hasTESTING: false,
    },
    getters: {
      isInactive: (state) => state.isInactive,
      isDispatcher: (state) => state.isDispatcher,
      isPEM: (state) => state.isPEM,
      isREE: (state) => state.isREE,
      isMy360: (state) => state.isMy360,
      hasDashboard: (state) => state.hasDashboard,
      isMobileeRollOut: (state) => state.isMobileeRollOut,
      hasRequestCreation: (state) => state.hasRequestCreation,
      hasTESTING: (state) => state.hasTESTING,
      hasHIS: (state) => state.hasHIS,
      hasRegulatoryControl: (state) => state.hasRegulatoryControl,
      authorizations: (state, getters) => {
        const list = Object.keys(state);
        const res = [];
        list.forEach((key) => {
          if (getters[key]) {
            res.push(key);
          }
        });
        return res;
      },
      hasAccess: (state, getters) => (requiredProfiles) => {
        const authorizations = getters.authorizations || [];
        if (!requiredProfiles) return true;
        const hasAccess = (element) => authorizations.includes(element);
        return requiredProfiles.some(hasAccess);
      },
    },
    mutations: {
      SET_AUTHORIZATION: (state, { key, value }) => {
        state[key] = value;
      },
    },
    actions: {
      setAuthorizations({ commit }, auth) {
        commit('SET_AUTHORIZATION', {
          key: 'isDispatcher',
          value: auth.isDispatcher,
        });
        commit('SET_AUTHORIZATION', {
          key: 'isInactive',
          value: auth.isInactive,
        });
        commit('SET_AUTHORIZATION', { key: 'isPEM', value: auth.isPEM });
        commit('SET_AUTHORIZATION', { key: 'isREE', value: auth.isREE });
        commit('SET_AUTHORIZATION', { key: 'isMy360', value: auth.isMy360 });
        commit('SET_AUTHORIZATION', {
          key: 'isMobileeRollOut',
          value: auth.isMobileeRollOut,
        });
        commit('SET_AUTHORIZATION', {
          key: 'hasDashboard',
          value: auth.hasDashboard,
        });
        commit('SET_AUTHORIZATION', {
          key: 'hasRequestCreation',
          value: auth.hasRequestCreation,
        });
        commit('SET_AUTHORIZATION', {
          key: 'hasTESTING',
          value: auth.hasTESTING,
        });
        commit('SET_AUTHORIZATION', {
          key: 'hasHIS',
          value: auth.hasHIS,
        });
        commit('SET_AUTHORIZATION', {
          key: 'hasRegulatoryControl',
          value: auth.hasRegulatoryControl,
        });
      },
    },
  });
};
